<template>
  <div class="bg-gray-lighten3 py-10 md:py-14">
    <div class="container overflow-hidden text-slate">
      <UiSectionTitle
        :title="$t('more_products')"
        class="title mb-8 flex whitespace-pre-line text-3xl uppercase leading-none text-slate md:justify-center md:text-center md:text-[3.5rem]"
      />

      <swiper-container ref="swiperEl" init="false" class="pb-11">
        <swiper-slide v-for="(item, i) in products" :key="i">
          <div class="w-[240px] md:w-[324px]">
            <CatalogProductCard
              :key="item.id"
              :name="item.name"
              :description="getProductContent(item).description"
              :is-new="item.marks.new"
              :image="getProductContent(item).image"
              :link="getProductContent(item).link"
              :tags="getProductContent(item).tags"
              :feature-groups="item.feature_groups"
            />
          </div>
        </swiper-slide>

        <div slot="container-end" class="swiper-scrollbar"></div>
      </swiper-container>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useSwiperElement } from '~/composables';
import CatalogProductCard from '~/domains/catalog/components/CatalogProductCard.vue';
import { getProductContent } from '~/helpers/vue';

interface Props {
  products?: any[];
}

withDefaults(defineProps<Props>(), {
  products: () => [],
});

const swiperOptions = {
  observer: true,
  slidesPerView: 'auto',
  spaceBetween: 16,
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
    dragSize: 180,
    snapOnRelease: true,
  },
};

const swiperEl = useSwiperElement(swiperOptions);
</script>
